{
  "actions": "الإجراءات",
  "hideButtonLabel": "إظهار أقل",
  "showAllButtonLabel": "عرض الكل ({tagCount, number})"
}
